import {
    Component,
    EventEmitter,
    forwardRef,
    Input,
    Output,
    ViewChild
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import {
    CurrentPersonDto,
    DO_NOTHING,
    LoggedInUser,
    UserService,
    UserStatus
} from '@flyfreely-portal-ui/flyfreely';
import { RichTextEditorComponent } from 'libs/rich-text-editor/src/lib/rich-text-editor/rich-text-editor.component';
import { Delta } from 'quill';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { Comment, CommentDelete, CommentUpdate } from '../interfaces';

@Component({
    selector: 'ui-comments',
    templateUrl: './comments.component.html',
    styleUrls: ['./comments.component.css'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CommentsComponent),
            multi: true
        }
    ]
})
export class CommentsComponent implements ControlValueAccessor {
    @Input() allowEdit = true;
    @Input() hasSave = true;
    @Input() organisationId!: number;
    @Input() comments: Comment[] = [];
    @Input() placeholderText?: string;
    @Output() updateComment = new EventEmitter<CommentUpdate>();
    @Output() createComment = new EventEmitter<Delta>();
    @Output() deleteComment = new EventEmitter<CommentDelete>();
    currentUser$: Observable<CurrentPersonDto>;

    @ViewChild(RichTextEditorComponent)
    richTextEditor!: RichTextEditorComponent;

    private onChange: (value: Comment[]) => void = DO_NOTHING;
    private onTouched: () => void = DO_NOTHING;

    constructor(private userService: UserService) {
        this.currentUser$ = this.userService.userChange$.pipe(
            filter(c => c.type === UserStatus.LOGGED_IN),
            map((changes: LoggedInUser) => changes.currentUser)
        );
    }

    writeValue(obj: Comment[]): void {
        if (obj) {
            this.comments = obj;
        } else {
            this.comments = [];
        }
    }

    registerOnChange(fn: (value: Comment[]) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        DO_NOTHING;
    }

    onCreateComment(commentContent: Delta) {
        this.createComment.emit(commentContent);
    }

    onUpdateComment($event: CommentUpdate) {
        this.updateComment.emit($event);
    }

    onDeleteComment($event: CommentDelete) {
        this.deleteComment.emit($event);
    }
}
